import { ChevronRightIcon } from "@heroicons/react/24/solid";
import React from "react";
import styled from "styled-components";

const BannerContainer = styled.a`
    background-color: #1db954;
    font-weight: 700;
    font-size: 16px;
    text-decoration: none !important;
    color: #f1f1f1;
    font-family: Gilroy;
    transition: all 0.2s ease-in-out;

    @media (min-width: 768px) {
        font-size: 18px;
    }

    &:hover {
        color: #ffffff;
        background-color: #00b33c;
    }

    position: sticky;
    top: 0;
    width: 100%;
    color: white;
    text-align: center;
    padding: 10px 0;
    z-index: 1050;
`;

const Banner: React.FC = () => {
    return (
        <BannerContainer
            className="d-flex justify-content-center py-2"
            href="/blackfriday"
        >
            <div className="max-w-sm mx-3">
                🔥
                <small style={{ marginLeft: "8px" }}>
                    Ente's last Black Friday sale
                </small>
                <ChevronRightIcon
                    style={{ width: "16px", marginLeft: "2px" }}
                />
            </div>
        </BannerContainer>
    );
};

export default Banner;
